import clsx from "clsx";
import React from "react";

import { LibrarySort } from "@growth-machine-llc/stridist-api-client";
import { JourneyAnchors, LibraryPrivacyFilter } from "../../constants";
import { CoachLibraryHeader } from "../library/CoachLibraryHeader";
import {
  CoachLibraryHeaderFiltersBaseProps,
  getLibraryPrivacyOptions,
} from "../exercise-library/CoachExerciseLibraryHeaderFilters";
import { useCurrentUser } from "../../hooks/useCurrentUser";

export interface CoachComponentTemplateLibraryHeaderFiltersProps
  extends CoachLibraryHeaderFiltersBaseProps {
  sortKey: LibrarySort;
  onChangeSortKey?: (sortKey: LibrarySort) => void;
  showFilterByType?: boolean;
}

export function CoachComponentTemplateLibraryHeaderFilters(
  props: CoachComponentTemplateLibraryHeaderFiltersProps,
) {
  const {
    className,
    query,
    onChangeQuery,
    privacy,
    onChangePrivacy,
    defaultQuery,
    showResetButton,
    disabledResetButton,
    showFilterByType,
    onResetFilters,
  } = props;

  const { isTeamAccount } = useCurrentUser();

  return (
    <CoachLibraryHeader<LibraryPrivacyFilter>
      className={className}
      query={query}
      defaultQuery={defaultQuery}
      searchPlaceholder={`Search by name`}
      onChangeQuery={onChangeQuery}
      toggleOptions={
        showFilterByType
          ? getLibraryPrivacyOptions("component", isTeamAccount)
          : undefined
      }
      toggleValue={privacy}
      onChangeToggle={onChangePrivacy}
      toggleClassName={clsx(JourneyAnchors.COMPONENT_TEMPLATE_PRIVACY_FILTER)}
      showResetButton={showResetButton}
      disabledResetButton={disabledResetButton}
      onResetFilters={onResetFilters}
    />
  );
}
